import React from "react";

export function ExportToast({ exportStatus, onDismiss }) {
  if (!exportStatus?.message && !exportStatus?.error) {
    return null;
  }

  const isError = Boolean(exportStatus.error);

  return (
    <div
      className={`export-toast ${isError ? "export-toast-error" : "export-toast-info"}`}
      role={isError ? "alert" : "status"}
    >
      <span>{exportStatus.error || exportStatus.message}</span>
      <button
        aria-label="Dismiss export message"
        className="export-toast-dismiss"
        onClick={onDismiss}
        type="button"
      >
        x
      </button>
    </div>
  );
}